import {
  Action,
  CHANGE_NAME,
  CHANGE_INDUSTRY,
  CHANGE_SECTOR,
  CHANGE_TYPE,
  CHANGE_CAPRANGE,
  CHANGE_RISK,
  SORT,
  SortableFields,
  CHANGE_PRICE_CHANGE_PERIOD,
  CHANGE_PRICE,
  RESET,
} from './actions';
import { Stocks_StockType, Stocks_StockRisk } from '../../../__generated__/globalTypes';
import { SortDirection } from 'types/common';
import { Range } from './consts';

interface State {
  actualName?: string;
  actualSector?: string;
  actualIndustry?: string;
  actualType: Stocks_StockType | null;
  actualCapRange?: Range;
  actualRisk?: Stocks_StockRisk;
  actualPriceChangePeriod: number;
  actualPrice?: number;
  sortedField: SortableFields;
  currency: 'USD';
  sortDirection: SortDirection;
}

const initialState: State = {
  currency: 'USD',
  actualType: null,
  actualPriceChangePeriod: 365,
  sortedField: 'capitalization',
  sortDirection: SortDirection.desc,
};

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case CHANGE_NAME:
      return {
        ...state,
        actualName: action.payload.name,
      };

    case CHANGE_SECTOR:
      return {
        ...state,
        actualSector: action.payload.name,
      };

    case CHANGE_INDUSTRY:
      return {
        ...state,
        actualIndustry: action.payload.name,
      };

    case CHANGE_TYPE:
      return {
        ...state,
        actualType: action.payload.type,
      };

    case CHANGE_CAPRANGE:
      return {
        ...state,
        actualCapRange: action.payload.range,
      };

    case SORT:
      return {
        ...state,
        sortedField: action.payload.field,
        sortDirection: action.payload.direction,
      };
    case CHANGE_RISK:
      return {
        ...state,
        actualRisk: action.payload.risk,
      };

    case CHANGE_PRICE_CHANGE_PERIOD:
      return {
        ...state,
        actualPriceChangePeriod: action.payload.period,
      };

    case CHANGE_PRICE:
      return {
        ...state,
        actualPrice: action.payload.price,
      };

    case RESET: {
      return initialState;
    }

    default:
      return state;
  }
};
